import { render, staticRenderFns } from "./RecusFiscaux.vue?vue&type=template&id=5360c4b2"
import script from "./RecusFiscaux.vue?vue&type=script&lang=js"
export * from "./RecusFiscaux.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/tonumeric/poureux-gestion/projects/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5360c4b2')) {
      api.createRecord('5360c4b2', component.options)
    } else {
      api.reload('5360c4b2', component.options)
    }
    module.hot.accept("./RecusFiscaux.vue?vue&type=template&id=5360c4b2", function () {
      api.rerender('5360c4b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/RecusFiscaux.vue"
export default component.exports